import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { GetBidChatQuery } from "lib/generated/app-service-gql/graphql";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "lib/hooks/api/utils";
import { useGraphQlQuery } from "../../useGraphQlClient";

const bidChatQuery = graphql(`
  query getBidChat($id: String!) {
    getBidChat(id: $id) {
      conversationId
      resourceId
      questionAndAnswer {
        question
        answer
        sources {
          document
          documentId
          chunkNumber
          locations {
            pageNumber
            bbox {
              x
              y
              width
              height
            }
          }
        }
      }
    }
  }
`);

export type AiBidConversation = GetBidChatQuery["getBidChat"][0];
export type AiBidQaContent = AiBidConversation["questionAndAnswer"][0];

export function useGetBidChat(
  id: string,
  options?: UseQueryOptions<GetBidChatQuery, unknown, GetBidChatQuery, QueryKey>,
) {
  const { data: reportData, ...rest } = useGraphQlQuery(
    ["get_bid_chat", id],
    bidChatQuery,
    [{ id }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return {
    data: reportData?.getBidChat,
    ...rest,
  };
}
